import React, {useCallback, useEffect} from "react";
import StorefrontSection from "./StorefrontSection";
import {IStorefrontSection} from "../../models/Storefront";
import {
    useDeleteStorefrontSectionMutation,
    useGetStorefrontSectionQuery,
    useSaveStorefrontSectionMutation
} from "../../store/endpoints/StorefrontSectionEndpoints";
import {MessageBar, MessageBarType, Panel, PanelType} from "@fluentui/react";
import {debounce} from "lodash";

interface IStorefrontSectionFloatingEditorProps {
    isGlobal?: boolean;
    storefrontSectionId: string;
    isOpen: boolean;
    closer?: () => void;
}
const StorefrontSectionFloatingEditor: React.FC<IStorefrontSectionFloatingEditorProps> = (props) => {
    const [saving, setSaving] = React.useState(false);
    const getSection = useGetStorefrontSectionQuery(props.storefrontSectionId ?? '', {skip: !props.storefrontSectionId || props.storefrontSectionId === ''})
    const [effectiveSection, setEffectiveSection ] = React.useState<IStorefrontSection>()
    const [sectionUpdater] = useSaveStorefrontSectionMutation()
    const [deleteSection] = useDeleteStorefrontSectionMutation();
    const [message, setMessage] = React.useState<string | undefined>(undefined);

    const onDelete = () => {
        if(effectiveSection?.storefront) {
            deleteSection({
                storefront: effectiveSection?.storefront,
                id: props.storefrontSectionId
            }).unwrap().then((response) => {

                setSaving(false);
                if (response.success) {
                    props.closer?.()
                } else {
                    setMessage(response.message ?? 'Unable to delete');
                }
            })
        }
    }
    useEffect(() => {
        if(getSection.data){
            setEffectiveSection(getSection.data)
        }
    }, [getSection]);

    const updateSection = (section: IStorefrontSection) => {
        setEffectiveSection({...section});
        debouncedUpdateSection(section)
    }

    const debouncedUpdateSection = useCallback(
        debounce((val:IStorefrontSection | undefined) => {
            if(val && effectiveSection?.storefront) {
                sectionUpdater({section: val, storefront: effectiveSection?.storefront});
            }
        }, 2000),
        [effectiveSection]
    );
    
    
    return(
        <Panel 
            isOpen={props.isOpen}
            onDismiss={() => {props.closer?.()}}
            type={PanelType.smallFluid}
            isFooterAtBottom={false}
        >
            {message && <MessageBar messageBarType={MessageBarType.error}>{message}</MessageBar> }
            {effectiveSection && <StorefrontSection
                saving={saving}
                currentIndex={0}
                section={effectiveSection}
                isGlobal={props.isGlobal}
                storefront={effectiveSection?.storefront}
                canMoveDown={false}
                onChange={(s, _) => updateSection(s)}
                onDelete={onDelete}
            />}
        </Panel>
    )
}

export default StorefrontSectionFloatingEditor;
